import { a as BaseTextAlignPlugin, c as BaseFontFamilyPlugin, l as BaseFontColorPlugin, n as BaseLineHeightPlugin, o as BaseFontWeightPlugin, s as BaseFontSizePlugin, t as BaseTextIndentPlugin, u as BaseFontBackgroundColorPlugin } from "../BaseTextIndentPlugin-CI3pK67_.js";
import { toPlatePlugin } from "platejs/react";

//#region src/react/FontPlugin.tsx
const FontColorPlugin = toPlatePlugin(BaseFontColorPlugin);
const FontSizePlugin = toPlatePlugin(BaseFontSizePlugin);
const FontFamilyPlugin = toPlatePlugin(BaseFontFamilyPlugin);
const FontBackgroundColorPlugin = toPlatePlugin(BaseFontBackgroundColorPlugin);
const FontWeightPlugin = toPlatePlugin(BaseFontWeightPlugin);

//#endregion
//#region src/react/LineHeightPlugin.tsx
const LineHeightPlugin = toPlatePlugin(BaseLineHeightPlugin);

//#endregion
//#region src/react/TextAlignPlugin.tsx
const TextAlignPlugin = toPlatePlugin(BaseTextAlignPlugin);

//#endregion
//#region src/react/TextIndentPlugin.tsx
const TextIndentPlugin = toPlatePlugin(BaseTextIndentPlugin);

//#endregion
export { FontBackgroundColorPlugin, FontColorPlugin, FontFamilyPlugin, FontSizePlugin, FontWeightPlugin, LineHeightPlugin, TextAlignPlugin, TextIndentPlugin };